// extracted by mini-css-extract-plugin
export default {"paymentMethodsHolder":"cwnfdz56i","paymentMethodsContainer":"cp9lcxzv1","holder":"cy580cq1l","text":"ckn6zfrgc","icon":"csen4u80u"};